import { ThirdPartyConfigDto } from "@repo/api/third-party-config";
import { AmplifilesClient } from "./api-client";
import { ThirdPartyVideoDto } from "@repo/api/third-party-video";
import { ThirdPartyEditorInfoDto } from "@repo/api/third-party-video";

export class ThirdPartyApi {
  static async getThirdPartyConfig(token: string) {
    const response = await AmplifilesClient.instance.get(
      `/third-party-config`,
      {
        params: {
          token,
        },
      },
    );

    return ThirdPartyConfigDto.parse(response.data);
  }

  static async upsertThirdPartyVideo(teamExternalId: string, token: string) {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/third-party-video`,
      {},
      {
        params: {
          token,
        },
      },
    );

    return ThirdPartyVideoDto.parse(response.data);
  }

  static async getThirdPartyEditorInfo(
    teamExternalId: string,
    videoExternalId: string,
  ) {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/video/${videoExternalId}/third-party-editor-info`,
    );

    return ThirdPartyEditorInfoDto.nullable().parse(response.data);
  }
}
